import React, { useContext } from 'react';
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  Paper,
  Box,
  TableCell,
  TableRow,
  Grid
} from '@material-ui/core';
import { useStyles } from './useStyles';
import { EditButton } from '../../../atoms/Button';
import { useHooks } from './useHooks';
import PaginationComponent from '../../../PaginationComponent';
import { SITE_PROCESS_DISPLAY_LIMIT_LIST } from '../../../../const/ProcessConst';
import { DEFAULT_MESSAGE_NO_DATA } from '../../../../const/Const';
import { SiteProcessDatePicker } from '../../input/ProcessDatePicker';
import { FormProvider, useForm, UseFormReturn } from 'react-hook-form';
import { SiteProcessSelectfield } from '../../input/ProcessSelectfield';
import { parsePrice } from '../../../../utils';
import { TDailyReportPageForm } from '../../../../types/dailyReport';
import { DailyReportAddModal } from '../DailyReportAddModal';
import { DailyReportUrlModal } from '../DailyReportUrlModal';
import { DailyReportEditModal } from '../DailyReportEditModal';
import { DailyReportDetailModal } from '../DailyReportDetailModal';
import { DailyReportDeleteModal } from '../DailyReportDeleteModal';
import { DAILY_REPORT_DVISION } from '../../../../const/DailyReportConst';
import { SiteProcessTextfield } from '../../input/ProcessTextfield';
import { SiteProcessCheckbox } from '../../input/ProcessCheckbox';
import LoadingIcon from '../../../atoms/LoadingIcon';
import { SiteProcessSelectBox } from '../../input/ProcessSelectBox';
import { withStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import { BasicSelect } from '../../input/BasicSelect';
import HelpIcon from '@material-ui/icons/Help';
import { CustomTooltip } from '../../../tooltip/CustomTooltip';
import { tooltipContents } from '../../../tooltip/Const';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { AuthInfoContext } from '../../../../AuthContextProvider';
import { ROLE } from '../../../../const/Const';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    },
    '&:nth-of-type(odd):hover': {
      backgroundColor: theme.palette.action.hover
    },
    '&:nth-of-type(even):hover': {
      backgroundColor: '#ffffff'
    }
  }
}))(TableRow);

type TProps = {
  defaultConstructId?: number;
  defaultStartDate?: string;
  defaultEndDate?: string;
};

export const DailyReportListView: React.FC<TProps> = (props: TProps) => {
  const { defaultConstructId, defaultStartDate, defaultEndDate } = props;

  const methods: UseFormReturn<TDailyReportPageForm> =
    useForm<TDailyReportPageForm>({
      reValidateMode: 'onSubmit',
      defaultValues: {
        construct_id: { value: 0, label: '--' },
        start_date: '',
        end_date: '',
        report_division: '種別',
        cost_up: false,
        cost_down: false,
        images: false,
        worker_name: '',
        display_limit: String(SITE_PROCESS_DISPLAY_LIMIT_LIST[0])
      }
    });

  const {
    setValue,
    handleSubmit,
    reset,
    formState: { errors }
  } = methods;

  const {
    pageCount,
    currentPage,
    dailyReportList,
    setCurrentPage,
    constructId,
    constructName,
    constructList,
    handleOnChangeConstructId,
    handleOnClickSearch,
    getReportDivisionName,
    handleOnClickAddButton,
    isOpenDailyReportAddModal,
    setIsOpenDailyReportAddModal,
    setDetailDailyReportId,
    handleOnClickUrlButton,
    isOpenDailyReportUrlModal,
    setIsOpenDailyReportUrlModal,
    handleOnClickDetailButton,
    detailDailyReportId,
    isOpenDailyReportDetailModal,
    setIsOpenDailyReportDetailModal,
    handleOnClickEditButton,
    editDailyReportId,
    isOpenDailyReportEditModal,
    setIsOpenDailyReportEditModal,
    handleOnClickExportImagesButton,
    endDate,
    handleChangeEndDatePicker,
    isEditableReport,
    searchParams,
    reRenderDailyReport,
    handleOnClickDeleteButton,
    isDeletableReport,
    isOpenDailyReportDeleteModal,
    setIsOpenDailyReportDeleteModal,
    deleteDailyReportId,
    isMovingPage,
    isLoading,
    isDownloading,
    renderDailyReportTrigger,
    checkCostUp,
    handleOnChangeCostUp,
    checkCostDown,
    handleOnChangeCostDown,
    checkImages,
    handleOnChangeImages
  } = useHooks({
    defaultConstructId,
    defaultStartDate,
    defaultEndDate,
    setValue,
    reset
  });

  const classes = useStyles();
  const history = useHistory();

  // サイズ調整
  const theme = useTheme();
  const isSmDownScreen = useMediaQuery(theme.breakpoints.up('sm'));
  const isMdDownScreen = useMediaQuery(theme.breakpoints.up('md'));
  const [authInfo, setAuthInfo] = useContext(AuthInfoContext);

  const isMobile: boolean = window.innerWidth < 500;

  return (
    <Box className={classes.listContainer}>
      {/* {(isMovingPage || isDownloading) && (
        <div className={classes.loadingIconClearWrapper}>
          <LoadingIconClear />
        </div>
      )} */}
      {isLoading && (
        <div className={classes.loadingContainer}>
          <LoadingIcon />
        </div>
      )}
      <Box
        className={
          `${classes.gridContainerPadding} ` +
          `${classes.searchItemContainer} ` +
          `${classes.borderBottomGray}`
        }
      >
        {/* 画面サイズによってスマホ表示に切り替え */}
        {isMdDownScreen ? (
          <Box style={{ display: 'flex' }}>
            <FormProvider {...methods}>
              <Box flex={1} className={`${classes.searchItemContainer}`}>
                {/* 案件 */}
                <Box
                  className={`${classes.selectBoxContainer} ${classes.searchItem}`}
                >
                  <SiteProcessSelectfield
                    name='construct_id'
                    label='案件'
                    listDatas={constructList}
                    onChange={handleOnChangeConstructId}
                    className={classes.constructInput}
                  />
                </Box>
                {/* 日付 */}
                <Box>
                  <Box
                    className={`${classes.selectBoxContainer} ${classes.searchItem}`}
                  >
                    <SiteProcessDatePicker
                      name='start_date'
                      label='開始日'
                      toDate={endDate}
                      errorMessage={errors?.start_date?.message}
                      errorMessageStyle={{ display: 'none' }}
                    />
                    <span className={classes.dateFromToSpan}>〜</span>
                    <SiteProcessDatePicker
                      name='end_date'
                      label='終了日'
                      onChange={handleChangeEndDatePicker}
                    />
                  </Box>
                  {errors.start_date && (
                    <Box className={`${classes.helperText}`}>
                      {errors?.start_date?.message}
                    </Box>
                  )}
                </Box>
                {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                  <>
                    {/* 種別 */}
                    <Box
                      className={`${classes.selectBoxContainer} ${classes.searchItem}`}
                    >
                      <SiteProcessSelectBox
                        name='report_division'
                        title={'種別'}
                        dataList={DAILY_REPORT_DVISION.map(division => {
                          return {
                            value: division.code,
                            label: `${division.name}`
                          };
                        })}
                        className={classes.selectBox}
                      />
                    </Box>
                    <Box className={classes.checkboxContainer}>
                      <label className={classes.checkboxLabel}>
                        <SiteProcessCheckbox
                          name='cost_up'
                          checked={checkCostUp}
                          onChange={handleOnChangeCostUp}
                        ></SiteProcessCheckbox>
                        原価UP
                      </label>
                      <label className={classes.checkboxLabel}>
                        <SiteProcessCheckbox
                          name='cost_down'
                          checked={checkCostDown}
                          onChange={handleOnChangeCostDown}
                        ></SiteProcessCheckbox>
                        原価DOWN
                      </label>
                      <label className={classes.checkboxLabel}>
                        <SiteProcessCheckbox
                          name='images'
                          checked={checkImages}
                          onChange={handleOnChangeImages}
                        ></SiteProcessCheckbox>
                        写真あり
                      </label>
                    </Box>
                    {/* 記入者 */}
                    <Box
                      className={`${classes.selectBoxContainer} ${classes.searchItem}`}
                    >
                      <SiteProcessTextfield
                        name='worker_name'
                        className={classes.workerNameInput}
                        label='記入者'
                      />
                    </Box>
                  </>
                )}
              </Box>
              {/* 表示数 セレクトボックス */}
              <Box flex={1} className={classes.searchButtonContainer}>
                <Box
                  className={`${classes.selectBoxContainer} ${classes.searchItem}`}
                  style={{ flexDirection: isMdDownScreen ? 'row' : 'column' }}
                >
                  <Box className={`${classes.searchItemLabel}`}>表示件数</Box>
                  <SiteProcessSelectBox
                    name='display_limit'
                    className={classes.selectBox}
                    dataList={SITE_PROCESS_DISPLAY_LIMIT_LIST.map(
                      displayLimit => ({
                        value: displayLimit,
                        label: `${displayLimit}件`
                      })
                    )}
                  />
                </Box>

                <Box className={classes.searchButtonWrapperBasic}>
                  <EditButton onClick={handleSubmit(handleOnClickSearch)}>
                    検索
                  </EditButton>
                </Box>
                <Box className={classes.toSiteProcessButtonWrapperBasic}>
                  <EditButton
                    onClick={() => {
                      history.push(`/processes`, {
                        constructId: constructId,
                        name: constructName
                      });
                    }}
                  >
                    <span
                      style={{ fontSize: isMdDownScreen ? '1em' : '0.95em' }}
                    >
                      工程表
                    </span>
                  </EditButton>
                </Box>
              </Box>
            </FormProvider>
          </Box>
        ) : (
          <FormProvider {...methods}>
            <Grid container className={`${classes.selectBoxContainer}`}>
              {/* 案件 */}
              <Grid item xs={12} className={`${classes.searchItem}`}>
                <SiteProcessSelectfield
                  name='construct_id'
                  label='案件'
                  listDatas={constructList}
                  onChange={handleOnChangeConstructId}
                />
              </Grid>
              {/* 日付 */}
              <Grid item xs={12}>
                <Box className={classes.dateInputContainerRwd}>
                  <SiteProcessDatePicker
                    name='start_date'
                    label='開始日'
                    toDate={endDate}
                    errorMessage={errors?.start_date?.message}
                    errorMessageStyle={{ display: 'none' }}
                    className={`${classes.searchItem}`}
                    inputProps={{
                      style: {
                        height: 34,
                        padding: '0 14px',
                        fontSize: '0.95rem'
                      }
                    }}
                  />
                  <div className={classes.dateFromToSpan}>〜</div>
                  <SiteProcessDatePicker
                    name='end_date'
                    label='終了日'
                    onChange={handleChangeEndDatePicker}
                    inputProps={{
                      style: {
                        height: 34,
                        padding: '0 14px',
                        fontSize: '0.95rem'
                      }
                    }}
                  />
                </Box>
                {errors.start_date && (
                  <Box className={`${classes.helperText}`}>
                    {errors?.start_date?.message}
                  </Box>
                )}
              </Grid>
              {/* 種別 */}
              <Grid item xs={12} className={`${classes.searchItem}`}>
                <SiteProcessSelectBox
                  name='report_division'
                  title={'種別'}
                  dataList={DAILY_REPORT_DVISION.map(division => {
                    return {
                      value: division.code,
                      label: `${division.name}`
                    };
                  })}
                  className={`${classes.selectBox} ${classes.divisionInput}`}
                />
              </Grid>
              <Grid item xs={12} className={classes.checkboxContainerRwd}>
                <label className={classes.checkboxLabel}>
                  <SiteProcessCheckbox
                    name='cost_up'
                    checked={checkCostUp}
                    onChange={handleOnChangeCostUp}
                  ></SiteProcessCheckbox>
                  原価UP
                </label>
                <label className={classes.checkboxLabel}>
                  <SiteProcessCheckbox
                    name='cost_down'
                    checked={checkCostDown}
                    onChange={handleOnChangeCostDown}
                  ></SiteProcessCheckbox>
                  原価DOWN
                </label>
                <label className={classes.checkboxLabel}>
                  <SiteProcessCheckbox
                    name='images'
                    checked={checkImages}
                    onChange={handleOnChangeImages}
                  ></SiteProcessCheckbox>
                  写真あり
                </label>
              </Grid>
              {/* 記入者 */}
              <Grid container xs={8}>
                <Grid item xs={12} className={`${classes.searchItem}`}>
                  <SiteProcessTextfield
                    name='worker_name'
                    className={classes.workerNameInputRwd}
                    label='記入者'
                  />
                </Grid>
              </Grid>
              {/* 表示数 セレクトボックス */}
              <Grid container xs={4}>
                <Grid item xs={12} className={`${classes.searchItem}`}>
                  <SiteProcessSelectBox
                    name='display_limit'
                    className={classes.selectBox}
                    dataList={SITE_PROCESS_DISPLAY_LIMIT_LIST.map(
                      displayLimit => ({
                        value: displayLimit,
                        label: `${displayLimit}件`
                      })
                    )}
                  />
                </Grid>
              </Grid>
              {/* 検索ボタン */}
              <Grid
                item
                xs={12}
                className={`${classes.textAlignRight} ${classes.searchButtonWrapperRwd}`}
              >
                <div>
                  <EditButton onClick={handleSubmit(handleOnClickSearch)}>
                    検索
                  </EditButton>
                </div>
                <div
                  style={{ paddingLeft: 8, borderLeft: '1px solid #cfcfcf' }}
                >
                  <EditButton
                    onClick={() => {
                      history.push(`/processes`, {
                        constructId: constructId,
                        name: constructName
                      });
                    }}
                  >
                    工程表
                  </EditButton>
                </div>
              </Grid>
            </Grid>
          </FormProvider>
        )}
      </Box>
      <Box className={classes.gridContainerPadding}>
        {isMobile ? (
          <Box className={classes.editButtonBoxMobile}>
            <EditButton
              onClick={handleOnClickAddButton}
              className={classes.editButtonMobile}
            >
              新規作成（現場管理）
            </EditButton>
            <EditButton
              onClick={handleOnClickUrlButton}
              className={classes.editButtonMobile}
            >
              URL発行（職人）
            </EditButton>
            <CustomTooltip title={tooltipContents.DailyReportUrl}>
              <HelpIcon color='action' />
            </CustomTooltip>
          </Box>
        ) : (
          <Box className={classes.textAlignRight}>
            <EditButton onClick={handleOnClickAddButton}>
              新規作成
              {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && '（現場管理）'}
            </EditButton>
            <EditButton onClick={handleOnClickUrlButton}>
              URL発行（職人）
            </EditButton>
            <CustomTooltip title={tooltipContents.DailyReportUrl}>
              <HelpIcon color='action' />
            </CustomTooltip>
          </Box>
        )}
      </Box>

      <TableContainer component={Paper}>
        <Table className={classes.main} aria-label='customized table'>
          <TableHead>
            <TableRow>
              <StyledTableCell
                style={{ minWidth: 100 }}
                className={classes.table}
                align='center'
              >
                日付
              </StyledTableCell>
              <StyledTableCell
                style={{ minWidth: 120 }}
                className={classes.table}
                align='center'
              >
                案件
              </StyledTableCell>
              {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                <StyledTableCell
                  style={{ minWidth: 100 }}
                  className={classes.table}
                  align='center'
                >
                  種別
                </StyledTableCell>
              )}
              <StyledTableCell
                style={{ minWidth: 140 }}
                className={classes.table}
                align='center'
              >
                記入者
              </StyledTableCell>
              <StyledTableCell
                style={{ minWidth: 200 }}
                className={classes.table}
                align='center'
              >
                登録日時
              </StyledTableCell>
              {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                <>
                  <StyledTableCell
                    style={{ minWidth: 160 }}
                    className={classes.table}
                    align='center'
                  >
                    原価UP
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ minWidth: 160 }}
                    className={classes.table}
                    align='center'
                  >
                    原価DOWN
                  </StyledTableCell>
                </>
              )}
              <StyledTableCell
                style={{ minWidth: 160 }}
                className={classes.table}
                align='center'
              >
                写真
              </StyledTableCell>
              <StyledTableCell
                style={{ minWidth: 100 }}
                className={classes.table}
                align='center'
              ></StyledTableCell>
              {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                <>
                  <StyledTableCell
                    style={{ minWidth: 100 }}
                    className={classes.table}
                    align='center'
                  ></StyledTableCell>
                  <StyledTableCell
                    style={{ minWidth: 100 }}
                    className={classes.table}
                    align='center'
                  ></StyledTableCell>
                  <StyledTableCell
                    style={{ minWidth: 100 }}
                    className={classes.table}
                    align='center'
                  ></StyledTableCell>
                </>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {dailyReportList &&
              dailyReportList.map(dailyReport => (
                <StyledTableRow className='click_table_row' title='編集'>
                  <StyledTableCell className={classes.table1} align='center'>
                    {dailyReport.work_day}
                  </StyledTableCell>
                  <StyledTableCell
                    id='status'
                    className={classes.table1}
                    align='center'
                    style={{ minWidth: 200 }}
                  >
                    {dailyReport.constructs.name}
                  </StyledTableCell>
                  {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                    <StyledTableCell
                      className={classes.table1}
                      align='center'
                      style={{ minWidth: 120 }}
                    >
                      {getReportDivisionName(dailyReport.report_division)}
                    </StyledTableCell>
                  )}
                  <StyledTableCell
                    className={classes.table1}
                    align='center'
                    style={{ minWidth: 120 }}
                  >
                    {dailyReport.writer_name}
                  </StyledTableCell>
                  <StyledTableCell
                    className={classes.table1}
                    align='center'
                    style={{ minWidth: 120 }}
                  >
                    {dailyReport.regist_date}
                  </StyledTableCell>
                  {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                    <>
                      <StyledTableCell
                        className={classes.table1}
                        align='center'
                        style={{ minWidth: 120 }}
                      >
                        {dailyReport.cost_up
                          ? parsePrice(dailyReport.cost_up.amount)
                          : '--'}
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.table1}
                        align='center'
                        style={{ minWidth: 120 }}
                      >
                        {dailyReport.cost_down
                          ? parsePrice(dailyReport.cost_down.amount)
                          : '--'}
                      </StyledTableCell>
                    </>
                  )}
                  <StyledTableCell
                    className={classes.table1}
                    align='center'
                    style={{ minWidth: 120 }}
                  >
                    {dailyReport.total_image_num}件
                  </StyledTableCell>

                  <StyledTableCell
                    className={classes.table1}
                    align='center'
                    style={{ minWidth: 30 }}
                  >
                    <EditButton
                      onClick={() => {
                        handleOnClickDetailButton(dailyReport.id);
                      }}
                    >
                      詳細
                    </EditButton>
                  </StyledTableCell>
                  {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                    <>
                      <StyledTableCell
                        className={classes.table1}
                        align='center'
                      >
                        <EditButton
                          onClick={() => {
                            handleOnClickEditButton(
                              dailyReport.id,
                              dailyReport.report_division
                            );
                          }}
                          className={
                            isEditableReport(dailyReport)
                              ? ''
                              : classes.disabledButton
                          }
                        >
                          編集
                        </EditButton>
                      </StyledTableCell>

                      <StyledTableCell
                        className={classes.table1}
                        align='center'
                        style={{ minWidth: 140 }}
                      >
                        <EditButton
                          onClick={() => {
                            handleOnClickExportImagesButton(dailyReport.id);
                          }}
                        >
                          写真出力
                        </EditButton>
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.table1}
                        align='center'
                      >
                        <EditButton
                          onClick={() => {
                            handleOnClickDeleteButton(dailyReport.id);
                          }}
                          className={
                            isDeletableReport(dailyReport)
                              ? ''
                              : classes.disabledButton
                          }
                        >
                          削除
                        </EditButton>
                      </StyledTableCell>
                    </>
                  )}
                </StyledTableRow>
              ))}
          </TableBody>
        </Table>
        {!isLoading && (!dailyReportList || dailyReportList.length === 0) && (
          <div className={classes.centerMessage}>{DEFAULT_MESSAGE_NO_DATA}</div>
        )}
      </TableContainer>

      <Box className={classes.pagenationContainer}>
        {dailyReportList && dailyReportList.length > 0 && (
          <PaginationComponent
            page={currentPage}
            pageCount={pageCount}
            setCurrentPage={setCurrentPage}
          />
        )}
      </Box>

      {/* 日報追加モーダル */}
      <DailyReportAddModal
        isOpen={isOpenDailyReportAddModal}
        setIsOpen={setIsOpenDailyReportAddModal}
        afterSubmit={reRenderDailyReport}
        constructId={constructId}
      />

      {/* URL発行モーダル */}
      <DailyReportUrlModal
        isOpen={isOpenDailyReportUrlModal}
        setIsOpen={setIsOpenDailyReportUrlModal}
        constructId={constructId}
      />

      {/* 詳細モーダル */}
      <DailyReportDetailModal
        isOpen={isOpenDailyReportDetailModal}
        setIsOpen={setIsOpenDailyReportDetailModal}
        dailyReportId={detailDailyReportId}
        setDailyReportId={setDetailDailyReportId}
        searchParams={searchParams}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        renderDailyReportTrigger={renderDailyReportTrigger}
      />

      {/* 編集モーダル */}
      <DailyReportEditModal
        isOpen={isOpenDailyReportEditModal}
        setIsOpen={setIsOpenDailyReportEditModal}
        afterSubmit={reRenderDailyReport}
        dailyReportId={editDailyReportId}
      />

      {/* 削除モーダル */}
      <DailyReportDeleteModal
        isOpen={isOpenDailyReportDeleteModal}
        setIsOpen={setIsOpenDailyReportDeleteModal}
        afterSubmit={reRenderDailyReport}
        dailyReportId={deleteDailyReportId}
      />
    </Box>
  );
};
